import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {get} from 'lodash';
import {Button} from 'ui-library';

import i18n from 'i18n';
import {setUserPermissions} from 'redux/modules/brands';
import {
  hideModal,
  resetRequest,
  sendRequest,
  showAlert
} from 'redux/modules/app';

import Dialog from 'modules/legacy/js/components/dialog';
import {AdvertisersPermissionsSelector} from 'modules/brands/advertiser/components';

const REQUEST_ID = 'setBrandUserPermissions';

function mapStateToProps({app}) {
  const {requests} = app;
  const request = requests[REQUEST_ID] || {};

  return {request};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setUserPermissions,
    hideModal,
    resetRequest,
    sendRequest,
    showAlert
  }, dispatch);
}

const UserPermissionDialog = createClass({
  propTypes: {
    brandUser: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    setUserPermissions: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    hideModal: PropTypes.func,
    resetRequest: PropTypes.func,
    sendRequest: PropTypes.func,
    showAlert: PropTypes.func
  },

  getInitialState() {
    return {
      hasError: false,
      selectedPermissions: get(this.props, 'brandUser.accessLevel')
    };
  },

  componentWillMount() {
    this.props.resetRequest(REQUEST_ID);
  },

  componentWillReceiveProps(props) {
    const {request} = props;

    if (request.status === 'success') this.onSuccess();
    if (request.status === 'fail') this.onFail();
  },

  onSuccess() {
    const {hideModal, showAlert, onSuccess, onClose} = this.props;

    if (onSuccess) onSuccess();
    if (onClose) onClose();
    if (!onClose) hideModal();

    showAlert({
      type: 'success',
      message: i18n.get('ADV_BRANDS_USER_PERMISSIONS_DIALOG_SUCCESS_ALERT_MESSAGE')
    });
  },

  onFail() {
    this.props.showAlert({
      type: 'error',
      message: i18n.get('ADV_BRANDS_USER_PERMISSIONS_DIALOG_ERROR_ALERT_MESSAGE')
    });
  },

  onPermissionsChange(newPermissions) {
    this.setState({
      selectedPermissions: newPermissions
    });
  },

  saveChanges() {
    const {brandUser, brand, setUserPermissions} = this.props;
    const {selectedPermissions: permissions} = this.state;

    setUserPermissions({
      permissions,
      userId: get(brandUser, 'userId'),
      brandId: get(brand, 'id')
    });
  },

  render() {
    const {hideModal, request, isOpen, onClose} = this.props;
    const {selectedPermissions, hasError} = this.state;
    const isLoading = request.status === 'loading';
    const content = (
      <div className='padding-2x'>
        <AdvertisersPermissionsSelector
          selectedPermissions={selectedPermissions}
          onChange={this.onPermissionsChange}
        />

        {hasError && (
          <div className='vf-text-danger margin-top-1x'>
            {i18n.get('ADV_BRANDS_USER_PERMISSIONS_DIALOG_ERROR_AT_LEAST_ONE')}
          </div>
        )}

        <div className='flex end-xs width100 margin-top-1x'>
          <Button className='margin-right-Hx' onClick={hideModal}>
            {i18n.get('ADV_BRANDS_USER_CLOSE')}
          </Button>

          <Button color='primary' onClick={this.saveChanges} disabled={isLoading}>
            {isLoading
              ? i18n.get('ADV_BRANDS_USER_PERMISSIONS_DIALOG_SAVING')
              : i18n.get('ADV_BRANDS_USER_PERMISSIONS_DIALOG_SAVE')
            }
          </Button>
        </div>
      </div>
    );

    return (
      <Dialog
        size='sm'
        header={i18n.get('ADV_BRANDS_USER_CARD_ROW_EDIT_PERMISSIONS')}
        content={content}
        isOpen={isOpen}
        onClose={onClose || hideModal}
      />
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPermissionDialog);
